<form [formGroup]="form">
    <datalist id="found-contacts-{{type}}-{{key || ''}}">
        @for (contact of contacts; track contact.id) {
            <option [value]="contact.name"></option>
        }
    </datalist>
    
    @if (displayLabel) {
        <label for="inquiry" class="text-nowrap">{{words[language][type] ? words[language][type] : 'Company Name'}}</label>
    }
    <div class="input-group input-group-sm">
        <input type="search" class="form-control form-control-sm" formControlName="inquiry" title="Find contact" [attr.list]="'found-contacts-' + type + '-' + (key || '')" id="inquiry-{{type}}-{{key || ''}}" 
            (keydown.enter)="saveContactQuickAdd()" placeholder="Find contact..." />
        @if (contactIdSelected > 0 && !isDisabled) {
            <div class="input-group-append clickable" (click)="getContactDetails(true)">
                <span class="input-group-text"><span class="dripicons-pencil"></span></span>
            </div>
        }
    </div>
</form>

<button type="button" class="d-none" [attr.data-target]="'#createNewContactModal_' + type + '_' + (key || '')" data-toggle="modal"
    id="createNewContactBtn_{{type}}_{{key || ''}}"></button>
<div class="modal fade" id="createNewContactModal_{{type}}_{{key || ''}}" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                View/Enter {{words[language][type]}} Contact Information
            </div>
            <div class="modal-body p-0">
                <datalist id="zip-codes">
                    @for (address of zipCodeList; track address) {
                        <option (click)="selectZipCode(address)" [value]="address.zipcode">{{address.zipcode}}, {{address.city}}</option>
                    }
                </datalist>
                <div class="card shadow-none">
                    <div class="card-body pb-0">
                        <form class="text-dark" [formGroup]="contactQuickAddInfo">
                            <div class="row">
                                <div class="form-group col-md-3 col-sm-12" [ngClass]="{'d-none': isIndividual}">
                                    <label for="companyName">Company Name</label>
                                    <input class="form-control text-dark" type="text" id="companyName"
                                        formControlName="companyName" autocomplete="off">
                                </div>
                                <div class="form-group col-md-3 col-sm-12">
                                    <label for="firstName">First Name</label>
                                    <input class="form-control text-dark" type="text" id="firstName"
                                        formControlName="firstName" autocomplete="off">
                                </div>
                                <div class="form-group col-md-3 col-sm-12" [ngClass]="{'d-none': !isIndividual}">
                                    <label for="middleName">Middle Name</label>
                                    <input class="form-control text-dark" type="text" id="middleName"
                                        formControlName="middleName" autocomplete="off">
                                </div>
                                <div class="form-group col-md-3 col-sm-12">
                                    <label for="lastName">Last Name</label>
                                    <input class="form-control text-dark" type="text" id="lastName"
                                        formControlName="lastName" autocomplete="off">
                                </div>
                                <div class="form-group col-md-3 col-sm-12">
                                    <label [ngClass]="{'d-none': isIndividual}">EIN</label>
                                    <label [ngClass]="{'d-none': !isIndividual}">Social Security Number</label>
                                    <input class="form-control text-dark" type="text" id="taxPayerNumber"
                                        formControlName="taxPayerNumber" autocomplete="off">
                                </div>
                                <div class="form-group col-md-3 col-sm-12">
                                    <label for="address">Address</label>
                                    <input class="form-control text-dark" type="text" id="address"
                                        formControlName="address" autocomplete="off">
                                </div>
                                <div class="form-group col-md-3 col-sm-12">
                                    <label for="address2">Address 2</label>
                                    <input class="form-control text-dark" type="text" id="address2"
                                        formControlName="address2" autocomplete="off">
                                </div>
                                <div class="form-group col-md-3 col-sm-12">
                                    <label for="zipCode">{{ words[language][ 'zipcode' ] }}</label>
                                    <div class="position-relative hover-list">
                                        <input class="form-control" type="text" id="zipCode_new"
                                            formControlName="zipCode" list="zip-codes" autocomplete="off">
                                    </div>
                                </div>
                                <div class="form-group col-md-3 col-sm-12">
                                    <label for="county">County</label>
                                    <input class="form-control text-dark" type="text" id="county"
                                        formControlName="county" autocomplete="off">
                                </div>
                                <div class="form-group col-md-3 col-sm-12">
                                    <label for="city">City</label>
                                    <input class="form-control text-dark" type="text" id="city" formControlName="city"
                                        autocomplete="off">
                                </div>
                                <div class="form-group col-md-3 col-sm-12">
                                    <label for="state">State</label>
                                    <input class="form-control text-dark" type="text" id="state" formControlName="state"
                                        autocomplete="off">
                                </div>
                                <div class="form-group col-md-3 col-sm-12">
                                    <label for="phoneNumber">Phone Number</label>
                                    <input class="form-control text-dark" type="text" id="phoneNumber"
                                        formControlName="phoneNumber" autocomplete="off">
                                </div>
                                <div class="form-group col-md-3 col-sm-12">
                                    <label for="emailAddress">Email Address</label>
                                    <input class="form-control text-dark" type="text" id="emailAddress"
                                        formControlName="emailAddress" autocomplete="off">
                                </div>
                            </div>
                            <div class="row" [ngClass]="{'d-none': !isIndividual}">
                                <div class="form-group col-md-3 col-sm-12">
                                    <label for="identificationTypeId">ID Type</label>
                                    <select class="custom-select" id="identificationTypeId"
                                        formControlName="identificationTypeId">
                                        @for (type of types; track type) {
                                        <option [value]="type.id">{{type.type}}
                                        </option>
                                        }
                                    </select>
                                </div>
                                <div class="form-group col-md-3 col-sm-12">
                                    <label for="number">ID Number</label>
                                    <input class="form-control text-dark" type="text" id="number"
                                        formControlName="number" autocomplete="off">
                                </div>
                                <div class="form-group col-md-3 col-sm-12">
                                    <label for="issuer">ID Issuer</label>
                                    <select id="issuer" class="form-control" formControlName="issuer">
                                        @for (issuer of issuers; track issuer) {
                                        <option [value]="issuer.abbreviation">
                                            {{issuer.name}}</option>
                                        }
                                    </select>
                                </div>
                                <div class="form-group col-md-3 col-sm-12">
                                    <label for="expirationDate">ID Expiry Date</label>
                                    <input class="form-control text-dark" type="date" id="expirationDate"
                                        formControlName="expirationDate" autocomplete="off">
                                </div>
                            </div>
                        </form>
                        @if ((contactIdSelected > 0) && (calledFrom !== 'sale')) {
                        <contact-roles [contactId]="contactIdSelected" [calledFrom]="calledFrom"
                            [type]="type"></contact-roles>
                        }
                    </div>
                </div>
            </div>
            <div class="modal-footer pt-0">
                <button class="btn btn-secondary" data-dismiss="modal"
                    id="btn-close-modal-create-new-contact_{{type}}_{{key}}">Cancel and
                    Close</button>
                <button class="btn btn-sm btn-primary" (click)="modifyContact()" id="saveContact_{{type}}_{{key}}"
                    [disabled]="contactQuickAddInfo.invalid">Save and Use
                    Contact</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->